// src/components/Layout/Topbar.js
import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const LOGO_URL =
  'https://stargaterentals.com/static/media/Logo.0be56ebbd11ef9d0de9d.png';

export default function Topbar({ onToggleSidebar }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar position="fixed" color="primary" elevation={0}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {/* Left: Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="img"
            src={LOGO_URL}
            alt="Stargate Rentals"
            sx={{ height: 34 }}
          />
        </Box>

        {/* Right side: nav + mobile menu */}
        <Box
          sx={{
            ml: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Right navigation links (desktop only, array currently empty) */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, fontSize: 13 }}>
            {[].map((item) => (
              <Typography
                key={item}
                variant="button"
                sx={{ letterSpacing: '0.1em', cursor: 'pointer' }}
              >
                {item}
              </Typography>
            ))}
          </Box>

          {/* Mobile menu button on the RIGHT */}
          {isMobile && (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="open sidebar"
              onClick={onToggleSidebar}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
